var React = require('react');

function Dot (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#0d3e4b;stroke:#707070;}.b{stroke:none;}.c{fill:none;}")),React.createElement("g",{"className":"a","key":1},[React.createElement("circle",{"className":"b","cx":"6","cy":"6","r":"6","key":0}),React.createElement("circle",{"className":"c","cx":"6","cy":"6","r":"5.5","key":1})])]);
}

Dot.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Dot;

Dot.default = Dot;
